var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallCalendarDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.733 5h-.882a.44.44 0 0 0-.441.441v3.087a.44.44 0 0 0 .441.441h.882a.44.44 0 0 0 .441-.441V5.441A.44.44 0 0 0 10.733 5zM20.435 8.969h-.882a.441.441 0 0 1-.441-.441V5.441c0-.243.198-.441.441-.441h.882c.243 0 .441.198.441.441v3.087a.441.441 0 0 1-.441.441z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.404 6.764h-2.646V9.41a.441.441 0 0 1-.441.441h-2.646a.441.441 0 0 1-.441-.441V6.764h-6.174V9.41a.441.441 0 0 1-.441.441H8.969a.441.441 0 0 1-.441-.441V6.764H5.882A.882.882 0 0 0 5 7.646v16.758c0 .487.395.882.882.882h18.522a.882.882 0 0 0 .882-.882V7.646a.882.882 0 0 0-.882-.882zm-.441 17.64H6.323a.441.441 0 0 1-.441-.441V12.056c0-.243.198-.441.441-.441h17.64c.243 0 .441.198.441.441v11.907a.441.441 0 0 1-.441.441z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallCalendarDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-calendar-default.3dbdb51a2233f6c84891f4210e25741f.svg";